var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('Breadcrumb',{attrs:{"title":_vm.$t('miracle_deal.title')}}),_c('Marquee'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }